import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

    let lastScrollTop = 0;
    const filterSection = document.querySelector('.section-filter'); 
    const $filterCollapse = $('#mobileFilterCollapse');

    window.addEventListener('scroll', function() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (window.innerWidth < 768 && filterSection) {
            if (scrollTop > lastScrollTop && scrollTop > 50) {

                filterSection.style.transform = "translateY(-110%)";
                filterSection.style.transition = "transform 0.4s ease-in";

                if ($filterCollapse.hasClass('show')) {
                    $filterCollapse.collapse('hide');
                }
                $('.select2-hidden-accessible').select2('close');

            } else {

                filterSection.style.transform = "translateY(0)";
                filterSection.style.transition = "transform 0.3s ease-out";
            }
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }, false);

	const propertyViewModule = {
        isLoading: false,
        init() {
            $(document).on('click', '.broker-show-agent-phone', this, this.showPhoneNumber);
            $(document).on('click', '.property-lead-send-btn', this, this.send);
        },
		showPhoneNumber(event) {
			const _this = event.data;
			event.preventDefault();

            var phone = $(this).data('text');
            $(this).find('span').text(phone);
            $(this).attr('href', 'tel:'+phone);
            $(this).removeClass('broker-show-agent-phone');
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();
            var element = this;

            var id = $(element).data('id');
            if (!id) {
                Swal.fire({
                    text: 'Invalid property ID!'
                });
                return false;
            }

            $('.property-lead-form').find('.form-control').removeClass('is-invalid');
            $('.property-lead-form').find('.form-check-input').removeClass('is-invalid');
            
            var errors = false;

            if ($('#property_lead_first_name').val() == '') {
                $('#property_lead_first_name').addClass('is-invalid');
                errors = true;
            }
            if ($('#property_lead_last_name').val() == '') {
                $('#property_lead_last_name').addClass('is-invalid');
                errors = true;
            }
            if ($('#property_lead_email').val() == '') {
                $('#property_lead_email').addClass('is-invalid');
                errors = true;
            }
            if ($('#property_lead_phone').val() == '') {
                $('#property_lead_phone').addClass('is-invalid');
                errors = true;
            }
            if (!$('#property_lead_terms_and_conditions').is(":checked")) {
                $('#property_lead_terms_and_conditions').addClass('is-invalid');
                errors = true;
            }

            if (errors) {
                return false;
            }

            //Loading...
            _this.isLoading = true;
			$(element).find('i').show();

            var values = '_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
            values += '&id=' + encodeURIComponent(id);
            values += '&first_name=' + encodeURIComponent($('#property_lead_first_name').val());
            values += '&last_name=' + encodeURIComponent($('#property_lead_last_name').val());
            values += '&email=' + encodeURIComponent($('#property_lead_email').val());
            values += '&phone=' + encodeURIComponent($('#property_lead_phone').val());
            values += '&company=' + encodeURIComponent($('#property_lead_company').val());
            values += '&message=' + encodeURIComponent($('#property_lead_message').val());
            values += '&newsletter=' + encodeURIComponent(($('#property_lead_newsletter').is(":checked")?1:0));
            $.ajax({
                type: "POST",
                url: baseURL + "/property/lead",
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').hide();

                    if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#property_lead_"+errorKey).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }

                        Swal.fire({
                            html: response.message+"<br>"+errorHtml
                        });

                        return false;
                    }

                    if (response.status == 1) {

                        $('.property-lead-form').find('.form-control').val('');
                        $('.property-lead-form').find('.form-check-input').attr('checked', false);

                        Swal.fire({
                            text: response.message
                        });

                        return;
                    }

                    Swal.fire({
                        text: response.message
                    });
                },
                error: function() {
                    _this.isLoading = false;
                    $(element).find('i').hide();
                }
            });

		}
    };

    const propertyListingModule = {
        isLoading: false,
        currentXhr: null,
        observer: null,

        init() {
            $(document).on('change', '.select-filter', () => this.applyFilters());

            $(document).on('change', '.filter-rooms-checkbox', () => {
                this.updateRoomsLabel();
                this.applyFilters();
            });

            $(document).on('change', '.filter-sort-option', (e) => {
                const $option = $(e.currentTarget);
                $('#filter-sort').val($option.val());
                $('.filter-sort .dropdown-item').removeClass('is-selected');
                $option.closest('.dropdown-item').addClass('is-selected');
                this.applyFilters();
            });

            $(document).on('click', '#btn-search-title', (e) => {
                e.preventDefault();
                if (window.innerWidth < 768) { $filterCollapse.collapse('hide'); }
                this.applyFilters();
            });

            $(document).on('keypress', '.search', (e) => {
                if (e.which == 13) this.applyFilters();
            });

            this.attachObserver();
        },

        attachObserver() {
            const sentinel = document.getElementById('property-load-more');
            if (!sentinel || !('IntersectionObserver' in window)) return;

            if (this.observer) this.observer.disconnect();

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) this.loadMore();
                });
            }, { rootMargin: '400px 0px' });

            this.observer.observe(sentinel);
        },

        loadMore() {
            if (this.isLoading) return;
            const $sentinel = $('#property-load-more');
            if ($sentinel.attr('data-has-more') != '1') return;

            const nextPage = parseInt($sentinel.attr('data-next-page'), 10);
            this.fetchPage(nextPage, false);
        },

        updateRoomsLabel() {
            const vals = $('.filter-rooms-checkbox:checked').map((i, el) => el.value).get();
            const allLabel = $('.select-filter-rooms').data('all-label') || '';
            $('.filter-rooms-text').text(vals.length ? vals.join(', ') : allLabel);
        },

        applyFilters() {
            if ($('#property-items-container').length === 0) return;

            const url = new URL(window.location.href);
            const rooms = $('.filter-rooms-checkbox:checked').map((i, el) => el.value).get().join(',');
            const filters = {
                'l': $('#filter-location').val(),
                'p': $('#filter-price').val(),
                't': $('#filter-type').val(),
                'query': $('#filter-title').val(),
                'sort': $('#filter-sort').val(),
                'r': rooms
            };

            Object.keys(filters).forEach(key => {
                if (filters[key] && filters[key] !== "") {
                    url.searchParams.set(key, filters[key]);
                } else {
                    url.searchParams.delete(key);
                }
            });

            url.searchParams.delete('page');
            window.history.pushState({}, '', url.toString());
            $('html, body').stop().animate({ scrollTop: 0 }, 400);

            this.fetchPage(1, true);
        },

        fetchPage(page, reset) {
            if (this.currentXhr) this.currentXhr.abort();

            this.isLoading = true;
            const $sentinel = $('#property-load-more');
            const $spinner = $sentinel.find('.property-load-more-spinner');
            $spinner.show();

            const url = new URL(window.location.href);
            url.searchParams.set('page', page);

            this.currentXhr = $.ajax({
                url: url.toString(),
                type: 'GET',
                dataType: 'json',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                success: (response) => {
                    const $grid = $('#property-items-grid');
                    if (reset) {
                        $grid.html(response.html);
                    } else {
                        $grid.append(response.html);
                    }

                    $sentinel.attr('data-next-page', response.nextPage);
                    $sentinel.attr('data-has-more', response.hasMore ? 1 : 0);
                    $sentinel.toggle(!!response.hasMore);

                    $spinner.hide();
                    this.isLoading = false;
                    this.currentXhr = null;
                },
                error: (xhr) => {
                    if (xhr.statusText === 'abort') return;
                    $spinner.hide();
                    this.isLoading = false;
                    this.currentXhr = null;
                }
            });
        }
    };

    if ($('#property-items-container').length) {
        propertyListingModule.init();
    }

    if ($('.property-page-container').length) {
        propertyViewModule.init();
    }
});
